export default __webpack_public_path__ + "static/PH-Summer-Sale-Homepage-Banner-Mobile-7f95fa688d9394e2490d181c81840594.webp";